module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back-btn"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.onBackClick
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n      Retour\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc8e910"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/BackBtn.vue
// module id = 102
// module chunks = 0